export enum Alert_State {
  UNKNOWN = 'UNKNOWN',
  NO_ALERT = 'NO_ALERT',
  ALERT_RAISED = 'ALERT_RAISED',
}
export enum Alert_Mech {
  UNKNOWN = 'UNKNOWN',
  PHONE = 'PHONE',
  EMAIL = 'EMAIL',
  EMAIL_PHONE = 'EMAIL_PHONE',
}
export enum Device_State {
  UNKNOWN = 'UNKNOWN',
  COMMISSIONED = 'COMMISSIONED',
  DECOMMISSONED = 'DECOMMISSONED',
  SUSPENDED = 'SUSPENDED',
  CALIBRATED = 'CALIBRATED',
  TRANSIT_IN = 'TRANSIT_IN',
  TRANSIT_OUT = 'TRANSIT_OUT',
  WITH_CUSTOMER = 'WITH_CUSTOMER',
  WITH_ENGINEER = 'WITH_ENGINEER',
  IN_INVENTORY = 'IN_INVENTORY',
  ORDERED_CUSTOMER = 'ORDERED_CUSTOMER',
  ORDERED = 'ORDERED',
  RETIRED = 'RETIRED',
}
export enum Country {
  NZ = 'NZ',
  AUS = 'AUS',
}
export enum TankShape {
  CYLINDER = 'CYLINDER',
  RECTANGLE = 'RECTANGLE',
}

export enum Permission {
  SUPPORT_ADMIN = 'SUPPORT_ADMIN',
  WHOLESALER = 'WHOLESALER',
  RESELLER = 'RESELLER',
  IMPLEMENTER = 'IMPLEMENTER',
  FARM_GROUP_MANAGER = 'FARM_GROUP_MANAGER',
  FARMER = 'FARMER',
  FARM_WORKER = 'FARM_WORKER',
  CUSTOMER = 'CUSTOMER',
}